import dayjs from 'dayjs'
import { NewsItem } from '@/types/News'

export function isLatestNewsWithin90Days(news: Pick<NewsItem, 'date'>[]) {
  if (news.length === 0) return false
  const now = dayjs()
  const latest = dayjs(news[0].date)
  return latest.isAfter(now.subtract(90, 'day'))
}

export function formatNewsDate(date: string) {
  return dayjs(date).format(`YYYY年M月D日`)
}
